import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('side-panel-content', {
  root: {
    variants: {
      skin: ['standard', 'floating'],
    },
    states: ['noPadding', 'stretchVertically'],
  },
});
